module.exports = __webpack_public_path__ + "media/src/images/icon/reservation-550869206a17fe29e4b628ae1688e11e.png";